import { motion } from "framer-motion";
import { Sparkles, Star } from "lucide-react";

// This component is now just a placeholder as the badge functionality 
// has been moved to QuizScoreMessage component
const QuizTrophy = () => {
  return null;
};

export default QuizTrophy;
